import { useState, useEffect } from "react";
import Modal from "../components/modal";
import { 
  getMaintenance, 
  resolveMaintenance, 
  createMaintenance, 
  getPrinterHistory,
  deleteMaintenance // 🆕 Certifique-se de exportar isso no seu service!
} from "../services/maintenanceservice";
import { getPrinters } from "../services/printerservice";
import { getClientes } from "../services/clientesservice";
import api from "../api/api"; // Caso precise de chamadas diretas

export default function Maintenance() {
  const [maintenances, setMaintenances] = useState([]);
  const [printers, setPrinters] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [activeTab, setActiveTab] = useState('pendente'); 
  const [isLoading, setIsLoading] = useState(true);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [isResolveModalOpen, setIsResolveModalOpen] = useState(false);
  
  const [selectedOS, setSelectedOS] = useState(null);
  const [osHistory, setOsHistory] = useState([]);
  const [actionText, setActionText] = useState("");

  const [newOS, setNewOS] = useState({ client_id: "", printer_id: "", issue_description: "" });

  useEffect(() => { loadInitialData(); }, []);
  useEffect(() => { fetchMaintenances(); }, [activeTab]);

  async function loadInitialData() {
    const [p, c] = await Promise.all([getPrinters(), getClientes()]);
    setPrinters(p || []); setClientes(c || []);
  }

  async function fetchMaintenances() {
    setIsLoading(true);
    const data = await getMaintenance(activeTab);
    setMaintenances(data || []);
    setIsLoading(false);
  }

  async function handleOpenDetails(os) {
    setSelectedOS(os);
    setIsDrawerOpen(true);
    const history = await getPrinterHistory(os.printer_id);
    setOsHistory(history || []);
  }

  async function handleCreateOS() {
    if(!newOS.printer_id || !newOS.issue_description) return alert("⚠️ Selecione a máquina e descreva o defeito!");
    await createMaintenance({ printer_id: newOS.printer_id, issue_description: newOS.issue_description });
    setIsNewModalOpen(false);
    setNewOS({ client_id: "", printer_id: "", issue_description: "" });
    fetchMaintenances();
  }

  async function handleFinalize() {
    await resolveMaintenance(selectedOS.id, { actions_taken: actionText });
    setIsResolveModalOpen(false);
    setIsDrawerOpen(false);
    fetchMaintenances();
  }

  // 🗑️ NOVA FUNÇÃO: EXCLUIR O.S.
  async function handleDeleteOS() {
    if (window.confirm("⚠️ ATENÇÃO LUIZ: Deseja realmente apagar esta O.S.? Esta ação é irreversível!")) {
      try {
        await deleteMaintenance(selectedOS.id);
        setIsDrawerOpen(false);
        fetchMaintenances();
        alert("Chamado removido com sucesso! 🗑️");
      } catch (err) {
        alert("Erro ao excluir o serviço.");
      }
    }
  }

  const availablePrinters = printers.filter(p => String(p.client_id) === String(newOS.client_id));

  return (
    <div className="p-8 lg:p-12 animate-in fade-in duration-500">
      <div className="mb-8 flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-black text-slate-900 tracking-tight"> Central de <span className="text-indigo-600">O.S</span></h1>
          <p className="text-slate-500 font-medium mt-1">Gestão de chamados e reparos técnicos.</p>
        </div>
        <button onClick={() => setIsNewModalOpen(true)} className="px-8 py-4 bg-indigo-600 text-white font-black rounded-2xl shadow-xl hover:bg-slate-900 transition-all active:scale-95">
          + Abrir Chamado 🛠️
        </button>
      </div>

      {/* TABS */}
      <div className="flex gap-2 mb-8 p-1.5 bg-slate-100 w-fit rounded-2xl border border-slate-200/50">
        <button onClick={() => setActiveTab('pendente')} className={`px-8 py-2.5 rounded-xl text-xs font-black transition-all ${activeTab === 'pendente' ? 'bg-white text-indigo-600 shadow-md' : 'text-slate-500'}`}>PENDENTES ({activeTab === 'pendente' ? maintenances.length : '...'})</button>
        <button onClick={() => setActiveTab('resolvido')} className={`px-8 py-2.5 rounded-xl text-xs font-black transition-all ${activeTab === 'resolvido' ? 'bg-white text-emerald-600 shadow-md' : 'text-slate-500'}`}>CONCLUÍDOS</button>
      </div>

      <div className="bg-white rounded-[40px] border border-slate-200 shadow-sm overflow-hidden mb-10">
        <table className="w-full text-left">
          <thead className="bg-slate-50/50 text-[10px] font-black uppercase text-slate-400 tracking-widest border-b border-slate-100">
            <tr>
              <th className="p-8">Status</th>
              <th className="p-8">Máquina / Cliente</th>
              <th className="p-8">{activeTab === 'pendente' ? 'Defeito' : 'Solução'}</th>
              <th className="p-8 text-right">Data</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {isLoading ? (
                <tr><td colSpan="4" className="p-20 text-center text-slate-300 font-bold uppercase tracking-widest">Sincronizando...</td></tr>
            ) : maintenances.map(m => (
              <tr key={m.id} onClick={() => handleOpenDetails(m)} className="hover:bg-slate-50/80 cursor-pointer transition-colors group">
                <td className="p-8">
                  <span className={`px-4 py-2 rounded-full text-[10px] font-black border ${m.alert === 'CRÍTICO' ? 'bg-red-50 text-red-600 border-red-100' : 'bg-emerald-50 text-emerald-600 border-emerald-100'}`}>{m.alert}</span>
                </td>
                <td className="p-8">
                  <p className="font-bold text-slate-800">{m.model}</p>
                  <p className="text-[10px] font-black text-indigo-500 uppercase">{m.client_name}</p>
                </td>
                <td className="p-8 text-sm text-slate-500 font-medium max-w-xs truncate">{activeTab === 'pendente' ? m.issue : m.solution}</td>
                <td className="p-8 text-right text-xs font-mono text-slate-400">{new Date(m.date).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* GAVETA LATERAL COM OPÇÃO DE EXCLUIR */}
      <div className={`fixed inset-y-0 right-0 w-[500px] bg-white shadow-2xl transform transition-transform duration-500 z-50 p-10 border-l border-slate-100 ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <button onClick={() => setIsDrawerOpen(false)} className="absolute top-8 right-8 text-slate-300 text-4xl font-light hover:text-red-500 transition-colors">&times;</button>
        {selectedOS && (
          <div className="mt-10 space-y-10">
            <div>
              <p className="text-[10px] font-black text-indigo-600 uppercase tracking-widest mb-1">{selectedOS.client_name}</p>
              <h2 className="text-4xl font-black text-slate-900 tracking-tight">{selectedOS.model}</h2>
            </div>
            
            <div className="p-8 bg-slate-900 text-white rounded-[40px]">
              <label className="text-[10px] font-black text-white/30 uppercase">Problema Reportado</label>
              <p className="text-lg font-bold mt-2 italic">"{selectedOS.issue}"</p>
            </div>

            <div className="space-y-3">
                {activeTab === 'pendente' && (
                <button onClick={() => setIsResolveModalOpen(true)} className="w-full py-6 bg-indigo-600 text-white font-black rounded-3xl hover:bg-slate-900 transition-all uppercase text-sm tracking-widest shadow-xl shadow-indigo-100">
                    Finalizar Manutenção ✅
                </button>
                )}
                
                {/* 🗑️ BOTÃO DE EXCLUIR */}
                <button onClick={handleDeleteOS} className="w-full py-4 bg-rose-50 text-rose-500 font-black rounded-3xl hover:bg-rose-600 hover:text-white transition-all uppercase text-[10px] tracking-widest">
                    Excluir Serviço 🗑️
                </button>
            </div>

            <div className="pt-10 border-t border-slate-100">
              <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-6">Histórico da Máquina</h3>
              <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                {osHistory.map((h, i) => (
                  <div key={i} className="p-6 bg-slate-50 rounded-[32px] border border-slate-100">
                    <p className="text-[10px] font-mono text-slate-400 mb-2">{new Date(h.date).toLocaleDateString()}</p>
                    <p className="text-sm font-bold text-slate-800 leading-tight">{h.issue}</p>
                    {h.solution && <p className="text-xs text-emerald-600 mt-2 italic font-bold">✓ SOLUÇÃO: {h.solution}</p>}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* MODAL: NOVO CHAMADO */}
      <Modal isOpen={isNewModalOpen} onClose={() => setIsNewModalOpen(false)}>
        <h2 className="text-3xl font-black mb-2 text-slate-900">Nova O.S</h2>
        <p className="text-sm text-slate-400 mb-8 font-medium">Selecione o cliente e a máquina com defeito.</p>
        <div className="space-y-4">
          <select className="w-full p-5 bg-slate-50 border border-slate-100 rounded-[24px] font-bold outline-none focus:border-indigo-500" onChange={e => setNewOS({...newOS, client_id: e.target.value, printer_id: ""})}>
            <option value="">Buscar Cliente...</option>
            {clientes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <select className="w-full p-5 bg-slate-50 border border-slate-100 rounded-[24px] font-bold outline-none" disabled={!newOS.client_id} onChange={e => setNewOS({...newOS, printer_id: e.target.value})}>
            <option value="">Escolha a Impressora...</option>
            {availablePrinters.map(p => <option key={p.id} value={p.id}>{p.model} (S/N: {p.serial_number})</option>)}
          </select>
          <textarea placeholder="Relato do defeito..." className="w-full p-6 bg-slate-50 border border-slate-100 rounded-[24px] h-40 outline-none focus:border-indigo-500 font-medium resize-none" onChange={e => setNewOS({...newOS, issue_description: e.target.value})} />
          <button onClick={handleCreateOS} className="w-full py-5 bg-indigo-600 text-white font-black rounded-3xl shadow-xl mt-4 uppercase text-xs tracking-widest">Abrir Chamado Técnico 🛠️</button>
        </div>
      </Modal>

      {/* MODAL: RESOLVER */}
      <Modal isOpen={isResolveModalOpen} onClose={() => setIsResolveModalOpen(false)}>
        <h2 className="text-3xl font-black mb-2 tracking-tight">Relatório de Reparo</h2>
        <p className="text-sm text-slate-400 mb-8 font-medium">O que foi feito para solucionar?</p>
        <textarea placeholder="Ex: Troca de roletes, limpeza..." className="w-full p-6 bg-slate-50 border border-slate-100 rounded-[24px] h-48 font-medium resize-none focus:border-emerald-500 outline-none" onChange={e => setActionText(e.target.value)} />
        <button onClick={handleFinalize} className="w-full py-5 bg-emerald-600 text-white font-black rounded-3xl mt-6 uppercase text-xs tracking-widest">Confirmar Solução ✅</button>
      </Modal>
    </div>
  );
}
